module.exports = __webpack_public_path__ + "static/media/study.4a2001e6.jpg";